export const buffs = [
  {
    isAvailable: ({ state }) => true,
    type: 'buffXpX2',
    field: 'hasX2Score',
    timerUntil: 'x2ScoreUntil',
    timerElapsed: 'x2ScoreElapsedTime',
    timerStart: 'x2ScoreFrom',
    reward: { value: 'x2', type: 'xp', noPlus: true },
  },
  {
    isAvailable: ({ state }) => true,
    type: 'buffCoinX2',
    field: 'hasX2Money',
    timerUntil: 'x2MoneyUntil',
    timerElapsed: 'x2MoneyElapsedTime',
    timerStart: 'x2MoneyFrom',
    reward: { value: 'x2', type: 'coin', noPlus: true },
  },
  {
    isAvailable: ({ state }) => state == 'games',
    type: 'buffGift5P',
    field: 'hasBonusGifts',
    timerUntil: 'bonusGiftsUntil',
    timerElapsed: 'bonusGiftsElapsedTime',
    timerStart: 'bonusGiftsFrom',
    reward: { value: '5%', type: 'charm' },
  },
];
